import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";


@Injectable()
export class GeneralConfiService {
  constructor(private _networkService: NetworkService) { }

  getawarnessList() {
    return this._networkService.get("api/general/awarenessList", null, null, "bearer");
  }
  getStepList() {
    return this._networkService.get("api/general/stepList", null, null, "bearer");
  }

  saveawarness(body: any) {
    return this._networkService.post("api/general/awareness", body, null, "bearer");
  }
  editawarness(body: any) {
    return this._networkService.put("api/general/awareness", body, null, "bearer");
  }
  savestep(body: any) {
    return this._networkService.post("api/general/step", body, null, "bearer");
  }
  editstep(body: any) {
    return this._networkService.put("api/general/step", body, null, "bearer");
  }

  deleteplan(id: any) {
    return this._networkService.delete("api/courseplan/" + id, null, "bearer")
  }

  saveSetting(body: any) {
    return this._networkService.post("api/setting/aboutUs", body, null, "bearer")
  }

  getSetting(query: any) {
    return this._networkService.get("api/setting/admin?" + query, null, null, null)

  }

}
